// components/JobChangerSection.jsx
import { ArrowRight } from 'lucide-react';
import im from "../../assets/Images/jobchanger.png"


import { Link } from 'react-router-dom';
export default function JobChangerSection() {
  return (
    <div className="bg-white py-2">
      <div className="max-w-7xl mx-auto px-2">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          {/* Left Content */}
          <div className="space-y-8">
            <h2 className="text-2xl md:text-2xl font-bold leading-tight text-gray-900">
              Are You a Job Changer<br />Looking for Something <span className="text-orange-600">Better?</span>
            </h2>

            <p className="text-xl text-gray-600 leading-relaxed max-w-lg">
              Find better jobs, flexible contracts, and global opportunities that match your next career move.
            </p>
<Link to='/jobs'>

            <button className="bg-orange-600 hover:bg-orange-700 text-white font-semibold text-lg px-10 py-4 rounded-2xl transition flex items-center gap-3 group">
              Find Jobs
              <ArrowRight className="group-hover:translate-x-1 transition" />
            </button>
</Link>
          </div>

          {/* Right Side - Visual */}
          <div className="relative flex justify-center lg:justify-end">
            <div className="relative bg-white rounded-3xl shadow-2xl overflow-hidden w-full max-w-md lg:max-w-lg">
              <img 
                src={im}
                alt="Job Changer Illustration"
                className="w-full h-auto object-cover"
              />

              {/* Overlay Graphic Elements */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="relative">
                  {/* Running Person */}
                  <div className="absolute -left-12 bottom-12 text-6xl animate-bounce">🏃‍♂️</div>
                  
                  {/* Big Red Envelope */}
                  <div className="absolute -right-8 top-8 bg-red-500 text-white font-bold text-xl px-8 py-6 rounded-2xl shadow-xl rotate-12 flex items-center gap-3">
                    <span>HIRING</span>
                    <span className="text-4xl">✉️</span>
                  </div>

                  {/* Hand holding envelope */}
                  <div className="absolute -right-16 top-6 text-6xl">👋</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}